<template>
  <div :class="{'modal':true, 'is-active':show}">

    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
        <header class="modal-card-head back-gradient-animation">
          <p class="modal-card-title has-text-centered">{{title}}</p>
          <button class="delete" aria-label="close" @click="$emit('close-modal')"></button>
        </header>
        <section class="modal-card-body">


            <div class="field">
                <label for="select_character" class="label">Personaje a transferir.</label>
                <div class="control">
                    <v-select 
                        @search="selectAction"
                        :options="characterSearch"
                        v-model="form.selected"
                        v-validate="'required'"
                        label="character"
                        name="receptor">
                        <span slot="no-options">No se ha encontrado ningun personaje.</span>
                    </v-select>
                </div>
                <p class="help">Escribe el nombre del personaje al cual quieras transferir Créditos.</p>
                <p class="help is-danger" v-show="errors.has('receptor')">Debe seleccionar un personaje.</p>
            </div>

        <hr>

        <div class="columns is-vcentered">
            <div class="column is-5">
                <h4 class="title is-5 has-text-grey">Créditos</h4>
                <p class="subtitle is-6 has-text-grey-dark">{{numberFormat(currentCredits)}}</p>
            </div>
            <div class="column">
                <div class="field">
                    <label class="label has-text-left">Cantidad a transferir:</label>
                    <div class="control">
                        <input type="text" class="input" 
                        v-model="form.mount" v-validate="'required|numeric||min_value:1'" 
                        name="cantidad" >
                    </div>
                    <p class="help has-text-left">Escribe la cantidad de Créditos que deseas transferir.</p>
                    <p class="help is-danger has-text-justified" v-if="errors.has('cantidad')">{{ errors.first('cantidad') }}</p>
                </div>
            </div>
        </div>

        <hr>
        <div class="field has-text-right">
            <label for="" class="label">Alias de envío</label>
            <div class="control">
                <div class="select">
                    <select v-model="form.alias" v-validate="'required'" name="alias">
                        <option v-for="(c,n) in characterOwn" :value="c.value" :key="n">{{c.value}}</option>
                        <option :value="'un Desconocido'">Anónimo</option>
                    </select>
                </div>
            </div>
            <p class="help">Elige con que nombre quieres enviar esta transferencia.</p>
            <p class="help is-danger" v-if="errors.has('alias')">{{ errors.first('alias') }}</p>
        </div>

        </section>
        <footer class="modal-card-foot">
          <div class="buttons has-addons is-right">
            <button class="button" @click="$emit('close-modal')" type="button">Cancelar</button>
            <button :class="{'button is-link':true, 'is-loading':loading,}" 
            @click="verifyBeforeSubmit()" type="button">
                Transferir
            </button>
          </div>
        </footer>
    </div>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
    name:'WebBanTransferModal',
    components: {
        vSelect
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        title: {
            type:String,
            default: ''
        },
        currentCredits: {
            type:Number,
            default:0
        },
        type: {
            default: 0,
            type:Number
        },
        characterSearch: {
            default: () => ([]),
            type: Array
        },
        characterOwn: {
            default: () => ([]),
            type: Array          
        }
    },
    data:()=>({
        form: {
            selected:'',
            mount:0,
            alias:''
        }
    }),
    computed: {
      numberFormat() {
        return this.$store.getters.numberWithCommas
      }
    },
    methods: {
        selectAction(search) {
            if (search.length > 1) this.$emit('setCharacters', search)
        },
        verifyBeforeSubmit() {
            this.$emit('loading-run')
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$emit('loading-stop')
                    return;
                }
                
                var message = ''
                if (this.form.mount > this.currentCredits) {
                    message = `No tienes suficientes Créditos en tu banco para transferir a esa cantidad.`
                    this.$toasted.show(message, { 
                        theme: 'toasted-danger', 
                        position: "top-center", 
                        duration : 5000
                    });
                    this.$emit('loading-stop')
                    return;
                }
                if (this.form.selected.character == '') {
                    message = `Debe seleccionar algún personaje.`
                    this.$toasted.show(message, { 
                        theme: 'toasted-danger', 
                        position: "top-center", 
                        duration : 5000
                    });
                    return;
                }

                this.$emit('form-submit', this.form)
            })
        }
    }
}
</script>

<style scoped>
    .buttons {
        width: 100%;
    }
</style>